// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__LIKaH","title":"AfterBackImages_title__2dIjT","images":"AfterBackImages_images__mj853"};